import React from 'react';
import Hero from '../components/sections/Hero';
import Principles from '../components/sections/Principles';
import Products from '../components/sections/Products';
import Approach from '../components/sections/Approach';
import Contact from '../components/sections/Contact';

export default function Home() {
  return (
    <>
      <Hero />
      <Principles />
      <Products />
      <Approach />
      <Contact />
    </>
  );
}
